<footer class="footer">
  <div class="container">
    <div class="footer-grid">
      <div class="footer-brand">
        <div class="logo footer-logo" style="margin-bottom: 4px">
          <img
            [src]="
              isDarkMode
                ? 'assets/images/LIVEPASS-w.png'
                : 'assets/images/LIVEPASS-b.png'
            "
            alt="EventHub Live"
            class="footer-logo-img"
            width="160"
            height="36"
          />
        </div>
        <p>
          Your gateway to extraordinary live experiences across India & the
          Middle East. Free listing, 7% on ticketing only.
        </p>
      </div>
      <div class="footer-col">
        <h4>Discover</h4>
        <a
          *ngFor="
            let category of discoverCategories;
            trackBy: trackFooterCategory
          "
          routerLink="/discover"
          [queryParams]="{ category: category.slug, city: city }"
        >
          {{ category.label }}
        </a>
      </div>
      <div class="footer-col">
        <h4>Popular Cities</h4>
        <a
          *ngFor="let city of footerCities; trackBy: trackFooterCity"
          href="#"
          (click)="pickCity(city, $event)"
        >
          {{ city.name }}
        </a>
      </div>
      <div class="footer-col">
        <h4>Company</h4>
        <a routerLink="/about-us">About Us</a>
        <!-- <a routerLink="/coming-soon">Careers</a>
        <a routerLink="/coming-soon">Press</a>
        <a routerLink="/coming-soon">Blog</a> -->
        <a routerLink="/coming-soon">Contact & Support</a>
      </div>
      <div class="footer-col">
        <h4>Support</h4>
        <!-- <a routerLink="/coming-soon">Help Center</a> -->
        <a routerLink="/refund-policy">Refund Policy</a>
        <a routerLink="/privacy">Privacy Policy</a>
        <a routerLink="/terms">Terms and Conditions</a>
        <a routerLink="/organizer-faq">Organizer FAQ</a>
      </div>
    </div>
    <div class="footer-bottom">
      <span class="footer-copy">© 2026 livepass.in · A MultiTV Group Platform</span>
      <div class="footer-social">
        <a href="#" title="X / Twitter" aria-label="X / Twitter">
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M17.53 3H20.6l-6.7 7.66L21.78 21h-6.17l-4.84-6.33L5.23 21H2.16l7.17-8.2L1.78 3h6.33l4.38 5.78L17.53 3Zm-1.08 16.15h1.7L7.18 4.76H5.36l11.09 14.39Z" fill="currentColor"/>
          </svg>
        </a>
        <a href="#" title="LinkedIn" aria-label="LinkedIn">
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M6.94 8.5a1.44 1.44 0 1 1 0-2.88 1.44 1.44 0 0 1 0 2.88ZM5.5 9.75h2.88V18H5.5V9.75Zm4.69 0h2.76v1.13h.04c.38-.73 1.33-1.5 2.74-1.5 2.93 0 3.47 1.93 3.47 4.44V18h-2.87v-3.72c0-.89-.02-2.03-1.24-2.03-1.24 0-1.43.97-1.43 1.97V18h-2.87V9.75Z" fill="currentColor"/>
          </svg>
        </a>
        <a href="#" title="Instagram" aria-label="Instagram">
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M7.75 3h8.5A4.75 4.75 0 0 1 21 7.75v8.5A4.75 4.75 0 0 1 16.25 21h-8.5A4.75 4.75 0 0 1 3 16.25v-8.5A4.75 4.75 0 0 1 7.75 3Zm0 1.75A3 3 0 0 0 4.75 7.75v8.5a3 3 0 0 0 3 3h8.5a3 3 0 0 0 3-3v-8.5a3 3 0 0 0-3-3h-8.5Zm8.88 1.31a1.06 1.06 0 1 1 0 2.12 1.06 1.06 0 0 1 0-2.12ZM12 7.5A4.5 4.5 0 1 1 7.5 12 4.5 4.5 0 0 1 12 7.5Zm0 1.75A2.75 2.75 0 1 0 14.75 12 2.75 2.75 0 0 0 12 9.25Z" fill="currentColor"/>
          </svg>
        </a>
        <a href="#" title="YouTube" aria-label="YouTube">
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M21.58 7.19a2.96 2.96 0 0 0-2.08-2.1C17.67 4.6 12 4.6 12 4.6s-5.67 0-7.5.49a2.96 2.96 0 0 0-2.08 2.1A31.3 31.3 0 0 0 2 12a31.3 31.3 0 0 0 .42 4.81 2.96 2.96 0 0 0 2.08 2.1c1.83.49 7.5.49 7.5.49s5.67 0 7.5-.49a2.96 2.96 0 0 0 2.08-2.1A31.3 31.3 0 0 0 22 12a31.3 31.3 0 0 0-.42-4.81ZM10.2 15.04V8.96L15.27 12l-5.08 3.04Z" fill="currentColor"/>
          </svg>
        </a>
      </div>
    </div>
  </div>
</footer>
